import React from "react";
import { StatusToggleSwitch } from "../StatusToggleSwitch";
import { miscMasterListing } from "../../redux/features/mastersSlice";

export const MiscMasterListingStatus = ({ params }) => {
    return (
        <div>
            <StatusToggleSwitch
                initialValue={params.isListed}
                api={miscMasterListing(params.miscMasterId)}
            />
        </div>
    );
};
